const toggleVisibilityRef = {
    isVisible: true,
    toggle() {
      this.isVisible = !this.isVisible;
      this.subscribers.forEach((fn) => fn(this.isVisible));
    },
    subscribers: [],
    subscribe(fn) {
      this.subscribers.push(fn);
      return () => {
        this.subscribers = this.subscribers.filter((f) => f !== fn);
      };
    },
  };
  
  export default toggleVisibilityRef;
  